import React from "react"
import camelCase from "lodash/camelCase"

import { Element } from "legacy/components/shared/base"
import Grid from "legacy/components/shared/Grid"
import { DisclaimerType } from "types/shared-components"
import { Maybe } from "types/Maybe"
import RichText from "legacy/components/shared/RichText"

interface OwnProps {
  data: Maybe<DisclaimerType>
}

export type DisclaimerProps = OwnProps

const Disclaimer: React.FC<DisclaimerProps> = ({
  data,
}): React.ReactElement | null => {
  if (!data?.primary) return null

  const { background_color, disclaimer_text } = data.primary
  const bgColor = background_color ? camelCase(background_color) : "white"

  return (
    <Element bg={bgColor} px="40" py={["30", "55"]}>
      <Grid maxWidth="contentWidth">
        <RichText
          fontSize={["12", "text.caption"]}
          letterSpacing="normal"
          lineHeight="1.825"
          opacity={0.4}
          render={disclaimer_text?.richText}
          variant="caption"
        />
      </Grid>
    </Element>
  )
}

export default Disclaimer
